/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Form, InputGroup, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Button, DropDown, Input } from "../../../components";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import * as yup from "yup";
import { useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  CourtBookingAmount,
  CreateCourtBooking,
  SendOtpBooking,
  ValidateBookingUser,
} from "../../../utilities/api/courtBooking";
import { VerifyOtpModal } from "./VerifyOtpModal";
import { ToastContainer, toast } from "react-toastify";
import { BookingDetailsType } from "../../../utilities/types";
import { messages } from "../../../utilities/Messages";

const CourtBookingCustomerDetails = (props: any) => {
  const { courtBookingData, setCourtBookingData, name } = props;
  const navigate = useNavigate();
  const [bookingData, setBookingData] = useState(courtBookingData);
  const [existingData, setExistingData] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [totalTax, setTotalTax] = useState(0);
  const [payOpp, setPayOpp] = useState({
    paymentMode: bookingData.paymentMode,
    isIgstTax: bookingData.isIgstTax,
    paymentMethod: bookingData.paymentMethod,
    discount: "",
  });
  const [message, setMessage] = useState("");
  const [disableAll, setDisableAll] = useState(true);
  const [submitButton, setSubmitButton] = useState(false);
  const [verifyButton, setVerifyButton] = useState(false);
  const getMessage = messages.courtbooking;
  const [schema, setSchema] = useState({
    firstName: yup
      .string()
      .required(getMessage.firstName_isNotEmpty)
      .matches(
        /^[a-zA-Z .-]+$/,
        getMessage.firstName_matches
      )
      .min(3, getMessage.firstName_minLength)
      .max(30, getMessage.firstName_maxLength),
    lastName: yup
      .string()
      .required(getMessage.lastName_isNotEmpty)
      .matches(
        /^[a-zA-Z .-]+$/,
        getMessage.lastName_matches
      )
      .min(1, getMessage.lastName_minLength)
      .max(30, getMessage.lastName_maxLength),
    phone: yup
      .string()
      .required(getMessage.phone_isNotEmpty)
      .matches(/^[0-9]\d{9}$/, getMessage.phone_matches),
    addressLine1: yup
      .string()
      // .required(getMessage.addressLine1_isNotEmpty)
      .notRequired()
      .max(50, getMessage.addressLine1_maxLength),
    addressLine2: yup
      .string()
      .max(50, getMessage.addressLine2_maxLength),
    landmark: yup.string().max(50, getMessage.landmark_maxLength),

    // gender: yup.string().required(getMessage.gender_isNotEmpty),
    gender: yup.string().notRequired(),
    email: yup
      .string()
      .nullable()
      .required(getMessage.email_isNotEmpty)
      .matches(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/, getMessage.email_invalid_email)
      .max(70, getMessage.email_maxLength),
    gstNumber: yup.string().nullable().notRequired().transform((value) => value === '' ? null : value).when("gstNumber", ([gstNumber], sch) => {
      return gstNumber
        ? sch
          .min(15, getMessage.gstNumber_maxLength)
          .max(15, getMessage.gstNumber_minLength)
        : sch.nullable().notRequired();
    }),

    pincode: yup
      .string()
      // .required(getMessage.pincode_isNotEmpty)
      .notRequired()
      .matches(/^[1-9][0-9]{5}$/, {
        message: getMessage.pincode_maxLength,
        excludeEmptyString: true,
      }),

    city: yup
      .string()
      // .required(getMessage.city_isNotEmpty)
      .notRequired()
      .max(50, getMessage.city_maxLength),


    state: yup
      .string()
      // .required(getMessage.state_isNotEmpty)
      .notRequired()
      .max(50, getMessage.state_maxLength),
  });

  useEffect(() => {
    if (courtBookingData.bookingType !== "individual") {
      setSchema(
        Object.assign(schema, {
          companyName: yup
            .string()
            .required(getMessage.company_isNotEmpty)
            .max(60, getMessage.comapny_maxLength)
            .matches(
              /^[a-zA-Z .-]+$/,
              getMessage.company_matches
            ),
        })
      );
    }
  }, [courtBookingData.bookingType]);

  const BookingDetailSchema = yup.object().shape(
    schema,
    [["gstNumber", "gstNumber"]]

  );
  const {
    formState: { errors },
    handleSubmit,
    register,
    reset,
  } = useForm<BookingDetailsType>({
    resolver: yupResolver(BookingDetailSchema),
  });
  const { states } = useAppSelector((state) => state.states);

  const handleSend = async () => {
    if (bookingData.phone.length === 10) {
      const result = await SendOtpBooking({
        phone: bookingData.phone,
        otpFor: "courtBooking",
      });
      if (result?.data?.statusCode === 200) {
        setModalShow(true);
        setMessage(result.data.data.otpNumber);
      } else {
        toast.error(result.response.data.message);
      }
    } else {
      toast(getMessage.phone_matches);
    }
  };

  const handleVerifiedUser = async () => {
    setVerifyButton(true);
    const result = await ValidateBookingUser({
      phone: bookingData.phone,
      bookingType: bookingData.bookingType,
    });
    if (result.status === 200) {
      let data = result.data.data;
      setExistingData({
        ...bookingData,
        companyName: data.companyUser?.company?.name,
        firstName: data.firstName,
        lastName: data.lastName,
        gstNumber: data.gstNumber,
        email: data.email,
        phone: data.phone,
        addressLine1: data.address?.addressLine1,
        addressLine2: data.address?.addressLine2,
        city: data.address?.city,
        state: data.address?.state,
        country: data.address?.country || "India",
        pincode: data.address?.pincode,
        landmark: data.address?.landmark,
        latitude: null,
        longitude: null,
        gender: data.gender,
      });
    } else {
      if (!result?.response?.data?.data?.allowForBooking) {
        setDisableAll(true);
        toast.error(result.response.data.message);
      }
      setExistingData({ ...courtBookingData });
    }
  };

  useEffect(() => {
    setCourtBookingData({ ...courtBookingData, phone: bookingData.phone });
    setVerifyButton(false);
  }, [bookingData.phone]);

  useEffect(() => {
    setBookingData(existingData);
    reset(existingData);
  }, [existingData]);

  const onSubmit: SubmitHandler<any> = async (data) => {
    setSubmitButton(true);
    let facilityId = Number(bookingData.facilityId);
    let selectedSlots = bookingData.selectedSlots?.map((item: any) => ({
      bookingDate: item.bookingDate,
      fromTime: item.fromTime,
      toTime: item.toTime,
    }));
    delete bookingData.amount;
    delete data.amount;
    const result = await CreateCourtBooking({
      ...bookingData,
      ...data,
      ...payOpp,
      facilityId: facilityId,
      selectedSlots: selectedSlots,
    });
    if (result.status === 200) {

      navigate("/court-booking-summary", { state: result.data.data.id });
    } else {
      handleGetAmount();
      toast.error(result.response.data.message);
    }
    setSubmitButton(false);
  };

  const handleGetAmount = async () => {
    let payload = {
      courtId: bookingData.courtId,
      facilityId: Number(bookingData.facilityId),
      sportId: bookingData.sportId,
      selectedSlots: courtBookingData.selectedSlots?.map((slot: any) => ({
        fromTime: slot.fromTime,
        toTime: slot.toTime,
        bookingDate: slot.bookingDate,
      })),
      isIgstTax: payOpp.isIgstTax,
      discount: payOpp.discount,
    };

    const result = await CourtBookingAmount(payload);
    if (result.status == 200) {
      let getTotalTax = 0;
      result.data.data.bookingTaxes.forEach((_tax: any) => {
        getTotalTax += _tax?.percentage;
      });

      setTotalTax(getTotalTax);
      setBookingData({ ...bookingData, amount: result.data.data });
    } else {
      toast.error(result.response.data.message);
    }
  };

  let timeOut: any;

  useEffect(() => {
    timeOut = setTimeout(() => {
      handleGetAmount();
    }, 1000);

    return () => clearTimeout(timeOut);
  }, [payOpp.discount, payOpp.isIgstTax]);

  const keyDown = (e: any) => {
    let num = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
    let key;
    num.forEach((item) => {
      if (item == e.key) {
        key = "true";
      }
    });

    if (key === "true") {
      clearTimeout(payOpp.discount);
      handleGetAmount();
    }
  };

  return (
    <>
      <Container fluid className="g-0">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Card>
            <Card.Body>
              <Card.Title className="text-start">Courts Booking</Card.Title>
              <Row>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="phone" className="form-label">
                      Contact Number <small className="text-danger">*</small>
                    </label>
                    <InputGroup>
                      <Input
                        value={bookingData.phone || ""}
                        type="number"
                        placeholder="Enter Contact Number"
                        id="phone"
                        name="phone"
                        className="form-control"
                        register={register}
                        required
                        onChange={(e: any) =>
                          setBookingData({
                            ...bookingData,
                            phone: e.target.value,
                          })
                        }
                        onKeyDown={(e: any) =>
                          ["e", ".", "-", "+"].includes(e.key) &&
                          e.preventDefault()
                        }
                        onKeyPress={(e: any) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleSend();
                          }
                        }}
                        onWheel={(e: any) => e.target.blur()}
                      />
                      <Button
                        disabled={verifyButton}
                        onClick={handleSend}
                        type="button"
                        bname={verifyButton ? "Verified" : "Verify"}
                        name="verify"
                        id="verify"
                        className="btn btn-sm btn-primary rounded-1"
                      ></Button>
                    </InputGroup>
                    <span className="error-msg">{errors?.phone?.message}</span>
                  </div>
                </Col>
                {bookingData.bookingType === "corporate" && (
                  <Col lg={6}>
                    <div className="mb-3 text-start">
                      <label htmlFor="companyName" className="form-label">
                        Corporate Name <small className="text-danger">*</small>
                      </label>
                      <Input
                        disabled={
                          bookingData.companyName?.length > 0 || disableAll
                        }
                        defaultValue={bookingData.companyName}
                        type="text"
                        placeholder="Enter Corporate Name"
                        id="companyName"
                        name="companyName"
                        className="form-control"
                        register={register}
                      />
                      <span className="error-msg">
                        {errors?.companyName?.message}
                      </span>
                    </div>
                  </Col>
                )}
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="fname" className="form-label">
                      First Name <small className="text-danger">*</small>
                    </label>
                    <Input
                      disabled={bookingData.firstName?.length > 0 || disableAll}
                      defaultValue={bookingData.firstName}
                      type="text"
                      placeholder="Enter First Name"
                      id="fname"
                      name="firstName"
                      className="form-control"
                      register={register}
                      required
                    />
                    <span className="error-msg">
                      {errors?.firstName?.message}
                    </span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="lname" className="form-label">
                      Last Name <small className="text-danger">*</small>
                    </label>
                    <Input
                      disabled={bookingData.lastName?.length > 0 || disableAll}
                      defaultValue={bookingData.lastName}
                      type="text"
                      placeholder="Enter Last Name"
                      id="lname"
                      name="lastName"
                      className="form-control"
                      register={register}
                      required
                    />
                    <span className="error-msg">
                      {errors?.lastName?.message}
                    </span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="gender" className="form-label">
                      Gender
                      {/* <small className="text-danger">*</small> */}
                    </label>
                    <DropDown
                      disabled={bookingData.gender?.length > 0 || disableAll}
                      defaultValue={bookingData?.gender}
                      name="gender"
                      id="addusergender"
                      className="form-control"
                      register={register}
                      // required
                    >
                      <option hidden disabled value="">
                        Select Gender
                      </option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </DropDown>
                    <span className="error-msg">{errors.gender?.message}</span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="gstnumber" className="form-label">
                      GST Number
                    </label>
                    <Input
                      disabled={bookingData.gstNumber?.length > 0 || disableAll}
                      defaultValue={bookingData.gstNumber}
                      type="text"
                      placeholder="Enter GST Number"
                      id="gstnumber"
                      name="gstNumber"
                      className="form-control"
                      register={register}
                    />
                    <span className="error-msg">
                      {errors.gstNumber?.message}
                    </span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="address" className="form-label">
                      Address Line 1
                      {/* <small className="text-danger">*</small> */}
                    </label>
                    <Input
                      disabled={
                        bookingData.addressLine1?.length > 0 || disableAll
                      }
                      defaultValue={bookingData.addressLine1}
                      type="text"
                      placeholder="Enter Address Line 1"
                      id="addressLine1"
                      name="addressLine1"
                      className="form-control"
                      register={register}
                      // required
                    />
                    <span className="error-msg">
                      {errors?.addressLine1?.message}
                    </span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="address" className="form-label">
                      Address Line 2
                    </label>
                    <Input
                      disabled={
                        bookingData.addressLine2?.length > 0 || disableAll
                      }
                      defaultValue={bookingData.addressLine2}
                      type="text"
                      placeholder="Enter Address Line 2"
                      id="addressLine2"
                      name="addressLine2"
                      className="form-control"
                      register={register}
                      required
                    />
                    <span className="error-msg">
                      {errors?.addressLine2?.message}
                    </span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="address" className="form-label">
                      Landmark
                    </label>
                    <Input
                      disabled={bookingData.landmark?.length > 0 || disableAll}
                      defaultValue={bookingData.landmark}
                      type="text"
                      placeholder="Enter landmark"
                      id="landmark"
                      name="landmark"
                      className="form-control"
                      register={register}
                      required
                    />
                    <span className="error-msg">
                      {errors?.landmark?.message}
                    </span>
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="pincode" className="form-label">
                      Pincode
                      {/* <small className="text-danger">*</small> */}
                    </label>
                    <Input
                      disabled={bookingData.pincode?.length > 0 || disableAll}
                      defaultValue={bookingData.pincode}
                      type="number"
                      placeholder="Enter pincode"
                      id="pincode"
                      name="pincode"
                      className="form-control"
                      register={register}
                      // required
                      onKeyDown={(e: any) =>
                        ["e", ".", "-", "+"].includes(e.key) &&
                        e.preventDefault()
                      }
                      onWheel={(e: any) => e.target.blur()}
                    />
                    <span className="error-msg">
                      {errors?.pincode?.message}
                    </span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="city" className="form-label">
                      City
                      {/* <small className="text-danger">*</small> */}
                    </label>
                    <Input
                      disabled={bookingData.city?.length > 0 || disableAll}
                      defaultValue={bookingData.city}
                      type="text"
                      placeholder="Enter City"
                      id="city"
                      name="city"
                      className="form-control"
                      register={register}
                      // required
                    />
                    <span className="error-msg">{errors?.city?.message}</span>
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="state" className="form-label">
                      State
                      {/* <small className="text-danger">*</small> */}
                    </label>
                    <DropDown
                      disabled={bookingData.state?.length > 0 || disableAll}
                      defaultValue={bookingData.state}
                      name="state"
                      id="booking-state"
                      className="form-control"
                      register={register}
                      // required
                    >
                      <option hidden disabled value="">
                        Select State
                      </option>
                      {states?.map((item: any) => {
                        return (
                          <option key={item.code} value={item.name}>
                            {item.name}
                          </option>
                        );
                      })}
                    </DropDown>
                    <span className="error-msg">{errors?.state?.message}</span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <label htmlFor="emailcourts" className="form-label">
                      Email <small className="text-danger">*</small>
                    </label>
                    <Input
                      disabled={bookingData.email?.length > 0 || disableAll}
                      defaultValue={bookingData.email}
                      type="email"
                      placeholder="Enter Email Address"
                      id="emailcourts"
                      name="email"
                      className="form-control"
                      register={register}
                    />
                    <span className="error-msg">{errors?.email?.message}</span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <div className="mb-3 text-start">
                    <Form.Check
                      onChange={(e: any) =>
                        setPayOpp({ ...payOpp, isIgstTax: e.target.value })
                      }
                      label="IGST"
                      name="isIgstTax"
                      type="checkbox"
                      id="igst"
                      value={payOpp.isIgstTax == "false" ? "true" : "false"}
                      checked={payOpp.isIgstTax === "false" ? false : true}
                    />
                  </div>
                </Col>
              </Row>

              <Row className="text-end">
                <hr />
                <Col md={{ span: 4, offset: 8 }} className="mb-3">
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Sub Total:{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {bookingData.amount?.subTotal.toFixed(2)}
                  </span>
                </Col>
                <Col md={{ span: 3, offset: 9 }}>
                  <div className="mb-3">
                    <Row className="align-items-baseline gx-2">
                      <Col md={6}>
                        <label
                          htmlFor="discount"
                          className="form-label text-uppercase text-info text-nowrap"
                        >
                          Discount :
                        </label>
                      </Col>
                      <Col md={6}>
                        <Input
                          onKeyDown={keyDown}
                          value={bookingData?.discount || payOpp?.discount || ""}
                          type="text"
                          placeholder="Discount"
                          id="discount"
                          name="discount"
                          className="form-control"
                          register={register}
                          onChange={(e: any) => {
                            if (
                              /^\d*\.?\d{0,2}$/.test(e.target.value) &&
                              e.target.value <= bookingData.amount?.subTotal
                            ) {
                              setPayOpp({
                                ...payOpp,
                                discount: e.target.value,
                              });
                            }
                          }}
                        />
                      </Col>
                    </Row>
                  </div>
                </Col>

                <Col md={{ span: 4, offset: 8 }} className="mb-3">
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Total Tax({totalTax}%):{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {bookingData.amount?.totalTax.toFixed(2)}
                  </span>
                </Col>

                <Col md={{ span: 4, offset: 8 }}>
                  <span className="user-info-title text-info text-uppercase mb-2">
                    Payable Amount:{" "}
                  </span>
                  <span className="user-info">
                    <span className="rupees-symbol">&#8377;</span>{" "}
                    {Math.round(bookingData.amount?.totalAmount)}
                  </span>
                </Col>
                <Col md={{ span: 6, offset: 6 }}>
                  <div className="mb-3 mt-3 text-end">
                    <div className="align-items-center d-flex justify-content-around">
                      {name === "SUPER_ADMIN" ? (
                        <>
                          <Form.Check
                            onChange={(e: any) =>
                              setPayOpp({
                                ...payOpp,
                                paymentMode: e.target.value,
                              })
                            }
                            checked={payOpp.paymentMode === "instant"}
                            label="Pay Now"
                            name="paymentMode"
                            type="radio"
                            id="pay-now"
                            value="instant"
                          />
                          <DropDown
                            disabled={payOpp.paymentMode !== "instant"}
                            value={payOpp.paymentMethod || ""}
                            className="form-control w-50"
                            name="paymentMethod"
                            id="paymentMethod"
                            register={register}
                            onChange={(e: any) =>
                              setPayOpp({
                                ...payOpp,
                                paymentMethod: e.target.value,
                              })
                            }
                          >
                            <option hidden disabled value="">
                              Select Payment Option
                            </option>
                            <option value="cash">Collect Cash</option>
                            <option value="online">Online</option>

                          </DropDown>
                          <Form.Check
                            onChange={(e: any) =>
                              setPayOpp({
                                ...payOpp,
                                paymentMode: e.target.value,
                                paymentMethod: "",
                              })
                            }
                            checked={payOpp.paymentMode === "later"}
                            label="Pay Later"
                            name="paymentMode"
                            type="radio"
                            id="pay-later"
                            value="later"
                          />
                        </>
                      ) : (
                        <>
                          <Form.Check
                            onChange={(e: any) =>
                              setPayOpp({
                                ...payOpp,
                                paymentMethod: e.target.value,
                                paymentMode: "instant",
                              })
                            }
                            checked={payOpp.paymentMethod === "cash"}
                            label="Collect Cash"
                            name="paymentMode"
                            type="radio"
                            id="pay-cash"
                            value="cash"
                          />
                          <Form.Check
                            onChange={(e: any) =>
                              setPayOpp({
                                ...payOpp,
                                paymentMethod: e.target.value,
                                paymentMode: "instant",
                              })
                            }
                            checked={payOpp.paymentMethod === "online"}
                            label="Share Payment link"
                            name="paymentMethid"
                            type="radio"
                            id="pay-online"
                            value="online"
                          />
                        </>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col className="text-end">
                  <Button
                    disabled={submitButton || !verifyButton}
                    type="submit"
                    bname={submitButton ? "Submiting..." : "Submit"}
                    name="next"
                    id="next"
                    className="btn btn-primary rounded-1 me-3"
                  ></Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </form>
        <VerifyOtpModal
          message={message}
          modalShow={modalShow}
          setModalShow={setModalShow}
          setMessage={setMessage}
          handleVerifiedUser={handleVerifiedUser}
          phone={bookingData.phone}
          setDisableAll={setDisableAll}
        />
      </Container>
      <ToastContainer />
    </>
  );
};
export { CourtBookingCustomerDetails };
